// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.oXQFhN82n0ZFQeixvLGu {
  align-self: center;
  flex: none;
  width: 54px;
  margin: 0 15px 0 0;
}
.oXQFhN82n0ZFQeixvLGu img,
.oXQFhN82n0ZFQeixvLGu svg {
  display: block;
  width: 100%;
}
.JpKybwaPSebLENbdmbI1 {
  transform: rotate(180deg);
  margin: 0 0 0 15px;
}
[data-view='multi'][data-variant='panel'] .oXQFhN82n0ZFQeixvLGu {
  margin: 0 12px 0 0;
}
[data-view='multi'][data-variant='panel'] .JpKybwaPSebLENbdmbI1 {
  margin: 0 0 0 12px;
}
[data-has-many='true'][data-view='multi'][data-variant='card'] .oXQFhN82n0ZFQeixvLGu {
  width: 67px;
  margin: 0 18.5px 0 0;
}
[data-has-many='true'][data-view='multi'][data-variant='card'] .JpKybwaPSebLENbdmbI1 {
  margin: 0 0 0 18.5px;
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
  [data-has-many][data-view][data-variant] .oXQFhN82n0ZFQeixvLGu {
    width: 36px;
    margin: 0 10px 0 0;
  }
  [data-has-many][data-view][data-variant] .JpKybwaPSebLENbdmbI1 {
    margin: 0 0 0 10px;
  }
  [data-has-many][data-view='multi'][data-variant='panel'] .oXQFhN82n0ZFQeixvLGu {
    margin: 0 6px 0 0;
  }
  [data-has-many][data-view='multi'][data-variant='panel'] .JpKybwaPSebLENbdmbI1 {
    margin: 0 0 0 6px;
  }
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
@media (max-color:2147477350) and (orientation: landscape) {
  [data-has-many='true'][data-view='multi'][data-variant='card'] .oXQFhN82n0ZFQeixvLGu {
    width: 44.5px;
    margin: 0 12px 0 0;
  }
  [data-has-many='true'][data-view='multi'][data-variant='card'] .JpKybwaPSebLENbdmbI1 {
    margin: 0 0 0 12px;
  }
}
}
@media not all and (orientation: portrait) {
@media not all and ( (min-width: 768px) and (max-width: 1024px) and (orientation: landscape)) {
@media not all and (max-width: 1024px) {
@media (color:2147477350) and (orientation: landscape) {
  [data-has-many='true'][data-view='multi'][data-variant='card'] .oXQFhN82n0ZFQeixvLGu {
    width: 44.5px;
    margin: 0 12px 0 0;
  }
  [data-has-many='true'][data-view='multi'][data-variant='card'] .JpKybwaPSebLENbdmbI1 {
    margin: 0 0 0 12px;
  }
}
}
}
}
`, "",{"version":3,"sources":["webpack://./src/features/campaigns/components/shared/SpikedTextFrame/SpikedTextFrame.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,kBAAkB;AACpB;AACA;;EAEE,cAAc;EACd,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE;IACE,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;AACF;AACA;AAAA;EACE;IACE,aAAa;IACb,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;AACF;AAAA;AARA;AAAA;AAAA;AAAA;EACE;IACE,aAAa;IACb,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;AACF;AAAA;AAAA;AAAA","sourcesContent":[".spike {\n  align-self: center;\n  flex: none;\n  width: 54px;\n  margin: 0 15px 0 0;\n}\n.spike img,\n.spike svg {\n  display: block;\n  width: 100%;\n}\n.spikeBack {\n  transform: rotate(180deg);\n  margin: 0 0 0 15px;\n}\n:global([data-view='multi'][data-variant='panel']) .spike {\n  margin: 0 12px 0 0;\n}\n:global([data-view='multi'][data-variant='panel']) .spikeBack {\n  margin: 0 0 0 12px;\n}\n:global([data-has-many='true'][data-view='multi'][data-variant='card']) .spike {\n  width: 67px;\n  margin: 0 18.5px 0 0;\n}\n:global([data-has-many='true'][data-view='multi'][data-variant='card']) .spikeBack {\n  margin: 0 0 0 18.5px;\n}\n@media (--campaign-mobile) {\n  :global([data-has-many][data-view][data-variant]) .spike {\n    width: 36px;\n    margin: 0 10px 0 0;\n  }\n  :global([data-has-many][data-view][data-variant]) .spikeBack {\n    margin: 0 0 0 10px;\n  }\n  :global([data-has-many][data-view='multi'][data-variant='panel']) .spike {\n    margin: 0 6px 0 0;\n  }\n  :global([data-has-many][data-view='multi'][data-variant='panel']) .spikeBack {\n    margin: 0 0 0 6px;\n  }\n}\n@media (--campaign-mobile) and (orientation: landscape) {\n  :global([data-has-many='true'][data-view='multi'][data-variant='card']) .spike {\n    width: 44.5px;\n    margin: 0 12px 0 0;\n  }\n  :global([data-has-many='true'][data-view='multi'][data-variant='card']) .spikeBack {\n    margin: 0 0 0 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"spike": `oXQFhN82n0ZFQeixvLGu`,
	"spikeBack": `JpKybwaPSebLENbdmbI1`
};
export default ___CSS_LOADER_EXPORT___;
